import * as t from 'io-ts';
import { isUndefined } from 'lodash-es';

import type { SelectDefinition } from 'header/types';

import { define, createSpecSettingsInterface } from './_common';

export interface TitleAlignSettingDefinition extends SelectDefinition {
    key: 'TITLE_ALIGN';
    value: TitleAlign;
}

export type TitleAlign = 'left' | 'right' | 'center';

export const TITLE_ALIGN_OPTIONS = [
    { key: 'center', label: 'center' },
    { key: 'left', label: 'left' },
    { key: 'right', label: 'right' },
] as const;

const definition: TitleAlignSettingDefinition = {
    type: 'Select',
    key: 'TITLE_ALIGN',
    changeable: true,
    label: 'Title align',
    options: [...TITLE_ALIGN_OPTIONS],
    value: 'center',
    scope: 'designer',
};

const specSettingsInterface = createSpecSettingsInterface(
    definition,
    t.union([t.literal('center'), t.literal('left'), t.literal('right')]),
);

export const codec = specSettingsInterface.input;

export const TitleAlignSettingDefinition = define({
    key: 'TITLE_ALIGN',
    label: 'titleAlign',
    definition,
    fromSetting: (settings, _, view) => {
        // prevents from creating a computed default setting for settings which are always created
        if (view) return undefined;

        return specSettingsInterface.extractValue(settings.titleAlign);
    },
    createDefinitionWithOpts: (opts = {}) => ({ ...definition, ...opts }),
    createDefinitionFromSpec: settings =>
        isUndefined(settings.titleAlign)
            ? // even if setting is not defined, we still want it to be available
              definition
            : specSettingsInterface.createDefinitionWithSettings(settings.titleAlign),
});
